const toFixedNumber = (num: string | number) => {
  if (typeof num == 'number') {
    return num.toFixed(2);
  } else {
    return parseFloat(num).toFixed(2);
  }
};

function toFixed(num: string | number, fixed: number) {
  const number =
    typeof num == 'number' ? num.toString().replace(/[^0-9.]/g, '') : num.replace(/[^0-9.]/g, '');
  const re = new RegExp('^-?\\d+(?:.\\d{0,' + (fixed || -1) + '})?');
  return number?.match(re)?.[0] ?? '';
}

function centsToDollar(cents?: number | string | null, removeTrailingCents?: boolean) {
  const numericCents = Number(cents);

  if (cents === null || cents === undefined || isNaN(numericCents)) return `$0.00`;

  let data = '';
  const negative = numericCents < 0;
  const absolute = Math.abs(numericCents);

  if (absolute % 100 < 10) {
    data = String(Math.floor(absolute / 100) + `.0${absolute % 100}`);
  } else {
    data = String(Math.floor(absolute / 100) + `.` + (absolute % 100));
  }

  let finalData = data.replace(/\d(?=(\d{3})+\.)/g, '$&,');
  if (removeTrailingCents) {
    finalData = finalData.replace(/\.00$/, '');
  }

  return `$${negative ? '-' : ''}${finalData}`;
}

function dollarToCents(dollar?: number | string) {
  let value = dollar;
  if (!value) {
    value = 0;
  }
  if (typeof value == 'string') {
    value = Number(value.replace(/[^0-9.]/g, ''));
  }
  try {
    return Math.round(value * 100);
  } catch {
    return 0;
  }
}

function centsToDollarWithoutComma(cents: number, removeTrailingCents?: boolean) {
  const dollar = centsToDollar(cents, removeTrailingCents);
  return dollar.replace(/,/g, '');
}

const formatNegativeAmounts = (amt?: number) => {
  if (amt) {
    if (amt < 0) {
      return `-${centsToDollar(Math.abs(amt))}`;
    } else {
      return centsToDollar(Math.abs(amt));
    }
  }
};

export {
  centsToDollar,
  centsToDollarWithoutComma,
  dollarToCents,
  formatNegativeAmounts,
  toFixed,
  toFixedNumber,
};
